<template>
  <el-drawer
    ref="drawer"
    :title="config.title"
    :before-close="handleClose"
    :visible.sync="drawer"
    direction="rtl"
    custom-class="edit_drawer"
    :wrapper-closable="false"
    size="40%"
  >
    <div class="drawer__content">
      <el-alert
        title="授权给客户后，该主体将作为货运签收方，参与到客户的货物签收与电子回单流程"
        type="warning"
        show-icon
        :closable="false"
      />
      <div class="search_bar">
        <div class="search">
          <el-input
            v-model="searchForm.searchKey"
            clearable
            :maxlength="50"
            placeholder="输入客户编码、客户简称、客户全称"
            @keyup.enter.native="fetchData(1,10)"
          />
          <el-button
            class="search_item"
            type="primary"
            @click="fetchData(1,10)"
          >
            查 询
          </el-button>
        </div>
        <div class="active">
          <el-button type="primary" @click="addAuthorization">
            添加授权
          </el-button>
        </div>
      </div>
      <list-block>
        <el-table
          v-loading="loading.table"
          :data="TableList"
          border
        >
          <el-table-column
            v-for="item in AUTHTABLECOLUMN"
            :key="item.props"
            :prop="item.prop"
            :label="item.label"
            show-overflow-tooltip
          >
            <template slot="header" slot-scope="{column}">
              <span v-if="item.prop === 'action'">
                {{ column.label }}
                <el-tooltip
                  effect="dark"
                  content="取消授权后，无法使用该主体的认证证书生成电子回单"
                  placement="top-end"
                >
                  <i class="el-icon-warning" />
                </el-tooltip>
              </span>
              <span v-else> {{ column.label }}</span>
            </template>
            <template slot-scope="scope">
              <div v-if="item.prop === 'action'">
                <el-button
                  type="text"
                  :loading="loading.cancel"
                  @click="cancelAuth(scope.row)"
                >
                  取消授权
                </el-button>
              </div>
              <span
                v-else
                v-text="item.formatter ? item.formatter(scope.row) : scope.row[item.prop]"
              />
            </template>
          </el-table-column>
        </el-table>
        <pagination
          ref="SitePagination"
          :total="pagination.total"
          :current-page.sync="pagination.page"
          @search="fetchData"
        />
      </list-block>
      <div class="drawer__footer">
        <el-button @click="handleClose">
          关 闭
        </el-button>
      </div>
    </div>
    <addAuth ref="addAuth" @reset="handleReset" />
  </el-drawer>
</template>

<script>
import { mainManageAuthPage, mainManageAuthCancel } from '@/api/principal';
import ListBlock from '@/components/ListBlock/index.vue';
import pagination from '@/components/Pagination/index.vue';
import { AUTHTABLECOLUMN } from '../constant';
import addAuth from './addAuth.vue';

export default {
  name: 'AuthorizationDialog',
  components: {
    ListBlock,
    pagination,
    addAuth,
  },
  data() {
    return {
      AUTHTABLECOLUMN,
      drawer: false,
      loading: {
        table: false,
        cancel: false,
      },
      pagination: {
        total: null,
        page: 1,
        size: 10,
      },
      TableList: [],
      form: {},
      searchForm: {},
      config: {},
    };
  },
  methods: {
    show(config) {
      this.config = config;
      this.fetchData();
      this.drawer = true;
    },
    handleClose() {
      this.searchForm = {};
      this.drawer = false;
    },
    handleReset() {
      this.pagination.page = 1;
      this.fetchData();
    },
    async fetchData(page = null, size = null) {
      this.loading.table = true;
      this.pagination.page = page || this.pagination.page;
      this.pagination.size = size || this.pagination.size;
      try {
        const res = await mainManageAuthPage({ creditCode: this.config.creditCode, ...this.searchForm }, { page: this.pagination.page, size: this.pagination.size });
        this.TableList = res.records;
        this.pagination.total = res.total;
        this.loading.table = false;
      } catch (error) {
        this.loading.table = false;
      }
    },
    addAuthorization() {
      this.$refs.addAuth.show({ creditCode: this.config.creditCode });
    },
    cancelAuth(row) {
      this.$confirm('取消授权后，客户无法再使用该主体生成电子回单', '取消授权', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          this.loading.cancel = true;
          await mainManageAuthCancel({ ids: [row.id], creditCode: this.config.creditCode });
          this.$message.success('取消成功');
          this.loading.cancel = false;
          this.fetchData();
        } catch (error) {
          this.loading.cancel = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
 ::v-deep .edit_drawer {
 .el-drawer__body{
  padding: 0 !important;
}
}
.drawer__content{
  padding: 24px;
  margin-bottom: 60px;
}
.drawer__footer{
  background: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 16px 24px;
  width: calc(100% - 48px);
  border-top: 1px solid #EBEEF5;
  text-align: right;
}
.search_bar{
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .search{
    flex: 1;
    display:flex;
    align-items: center;
    margin-right: 40px;
    .search_item{
      margin-left: 12px;
    }
  }
}
</style>
